import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';

import RenderError from '../assets/troubleshooting/6.3-render-error.png';
import ConfigError from '../assets/troubleshooting/6.4-config-error.png';
import SQLError from '../assets/troubleshooting/6.5-sql-error.png';
import FaultRecovery from '../assets/troubleshooting/fault-recovery.png';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SITroubleshootOverview = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Troubleshooting</Breadcrumb.Item>
							<Breadcrumb.Item active>SMARTInspect Troubleshooting</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="SMARTInspect Troubleshooting" className="mb-3">
								<Tab eventKey="SMARTInspect Troubleshooting" title="SMARTInspect Troubleshooting">
									<h2>SMARTINSPECT TROUBLESHOOTING</h2>

									<p>The SMARTInspect system is set up with a control and monitoring system that automatically handles a number of basic troubleshooting aspects, however no system is completely bullet-proof.</p>

									<p>In this section are some issues that may arise as well as methods that may solve those issues.</p>
								</Tab>
								<Tab eventKey="PowerPaint 'Rendering' Issues" title="PowerPaint 'Rendering' Issues">
									<div class="tab-section" style={{ justifyContent: 'space-between', display: 'flex' }}>
										<div class="left-side" style={{}}>
											<h2>POWERPAINT 'RENDERING' ISSUES</h2>
											<p>In the event that a plugin renders in an incorrect or incomplete fashion, the simplest method to restore functionality is often closing the plugin (via the large “close” button highlighted in Figure 6 3: Process Viewer Render Error (Render w/o Processes)) and reopening the desired plugin.</p>
											<p>In the event that does not resolve the issue, check that the issue is not due to any of the sections mentioned below. If not, restart the PowerPaint HMI and verify that the issue has been resolved.</p>
										</div>
										<div class="right-side">
											<figure>
												<img src={RenderError} alt="Master Key Box" style={{ width: '50vw', margin: '20px' }} />
												<figcaption>Figure 1: Process Viewer Render Error</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="'Missing' Configuration Files" title="'Missing' Configuration Files">
									<div class="tab-section" style={{ justifyContent: 'space-between', display: 'flex' }}>
										<div class="left-side" style={{}}>
											<h2>'MISSING' CONFIGURATION FILES</h2>
											<p>In the event of a runtime error as seen above, it is possible that a necessary configuration file is corrupt or missing. Generally, the error will report where the file is expected to be found.</p>
											<p>In the case of this type of issue, please refer to the section Configuration File Setup, supplementary material, or contact Inovision directly for further support.</p>
										</div>
										<div class="right-side">
											<figure>
												<img src={ConfigError} alt="Master Key Box" style={{ width: '45vw', margin: '20px' }} />
												<figcaption>Figure 1: Configuration File Runtime Error</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="SQL Server Exceptions" title="SQL Server Exceptions">
									<div class="tab-section" style={{ justifyContent: 'space-between', display: 'flex' }}>
										<div class="left-side" style={{}}>
											<h2>SQL SERVER EXCEPTIONS</h2>
											<p>The SQL server is a database used to store scan data, errors, faults, user information, and other useful system data. It is often accessed by various plugins as an organized method of collecting data about SMARTInspect operation.</p>
											<p>In the case that the above error message (or similar) appear on plugins that may get their information from the SQL server (e.g., getting scan information, fault information, etc.) the reason may be due to an incorrectly set up or inaccessible SQL server.</p>
											<p>The best method of resolving is simply waiting a few minutes to check that the SQL server is actually inaccessible – if the situation doesn’t resolve itself, attempt to restart the ImageCapture server and try again. </p>
											<p>In the event the problem continues to persist, it could signal a larger issue with the SQL server than expected, please contact Inovision Inc. for a more complete solution.</p>
										</div>
										<div class="right-side">
											<figure>
												<img src={SQLError} alt="Master Key Box" style={{ width: '41vw', margin: '20px' }} />
												<figcaption>Figure 1: SQL Runtime Fault Error Example</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Recovering from Fault State" title="Recovering from Fault State">
									<div class="tab-section" style={{ justifyContent: 'space-between', display: 'flex' }}>
										<div class="left-side" style={{}}>
											<h2>RECOVERING FROM A FAULT STATE</h2>
											<p>The following procedure describes what to do in the event of a fault condition.</p>
											<ol>
												<li>
													When a fault occurs, the red light on the System Control Console (<b>SCC</b>) stack light will illuminate.
												</li>
												<li>
													At the System Control Console (<b>SCC</b>), read the description to determine the cause. Once the reason for the fault is remedied, press the FAULT RESET button, and reset the safety circuit.
												</li>
											</ol>
											<p>It is possible that due to an unexpected delay in processing images (i.e., due to an extremely heavily damaged hood), unexpected positioning of vehicle carriers, or simply a hardware fault that a scan gets missed. The system will log this as a fault and attempt to prepare for the next scan.</p>
											<ol start={'2'}>
												<li>Wait for five (5) minutes after the first fault. The PP Monitor program automatically attempts to get the status of each service running, if any of them are “unhealthy” or “unresponsive” it will restart them automatically.</li>
												<li>
													If the issue still isn’t resolved, the next best thing to do is restart the service. This can be accomplished a number of ways:
													<ol type="a">
														<li>
															Switch to the server as detailed in the Server Interface / Display Switch Operation and:
															<ol type="i">
																<li>Restart the faulted service (select the command interface of the unhealthy service and press CTRL+C).</li>
																<li>Open PP Monitor (referenced in the Manual Start / Stop Procedure section) and restart all processes (press “stop all”, wait, press “start all”).</li>
															</ol>
														</li>
														<li>Use the Server Process Monitor detailed in the PowerPaint Plugins section to remotely restart the service.</li>
													</ol>
												</li>
												<li>If the issue persists or is not rectified upon the restarting of all services, it may be that the server itself is in a bad state. Reboot the server similar to the procedure defined in the Server Power Shutdown Procedure: Monitoring section but press “restart” instead of “shut down.”</li>
												<li>If the issue still isn’t resolved it may be a sign of a deeper or more serious issue, contact Inovision Inc. for further support.</li>
											</ol>
										</div>
										<div class="right-side">
											<figure>
												<img src={FaultRecovery} alt="Master Key Box" style={{ width: '24vw', margin: '20px' }} />
												<figcaption>Figure 1: System Control Console (SCC)</figcaption>
											</figure>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SITroubleshootOverview;
